/** Public artist URL. Prefers the short `code`; a numeric id still opens the page. */
export function artistPath(artist: { id: number | string; code?: string | null }, suffix = ""): string {
  return `/artists/${artist.code || artist.id}${suffix}`;
}
